import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import {DesktopDataAccessSharedModule} from '@brightside-web/desktop/data-access/shared';
import { BrightsideUiServicesModule } from '@brightside/brightside-ui-services';
import {SharedDisplayModule} from "@brightside-web/shared/display";
import {TranslateModule, TranslatePipe} from "@ngx-translate/core";

import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { SharedConsentsModule } from "@brightside-web/shared/consents";

import {
  AuthGuard,
  NoAuthGuard,
  RequiredVerificationGuard,
  SharedDesktopModule, GuidGuard, ReferralGuard, IdentityGuard,

} from '@brightside-web/shared/desktop';
import { SharedAccountModule } from '@brightside-web/shared/account';


import { CreateAccountComponent } from './create-account/create-account.component';
import { IdentityVerification } from './identity-verification';
import { BrightsideUiModule, ngxMaskOptions, NgxMaskModule } from '@brightside/brightside-ui';
import { ReactiveFormsModule } from '@angular/forms';

import { RegistrationComponent } from './registration/registration.component';

import { SignInPromptComponent } from './sign-in-prompt/sign-in-prompt.component';
import { LoginComponent } from './login/login.component';
import { GetTheAppComponent } from './get-the-app/get-the-app.component';


import { ROUTES as UNKNOWN_ROUTES, ROUTES_PATH as UNKNOWN_PATH } from './routes/unknown';
import { ReferralComponent } from './referral/referral.component';

const routes: Routes = [
  {
    path: '',
    component: RegistrationComponent,
    children: [
      { path: UNKNOWN_PATH, children: UNKNOWN_ROUTES },
      { path: 'select-employer', redirectTo: '/eligibility/select-employer'},
      { path: 'type', redirectTo: '/eligibility/type'},
      { path: 'identity', redirectTo: '/eligibility/identity'},
      { path: 'status', redirectTo: '/eligibility/status'},
      { path: 'get-the-app', component: GetTheAppComponent, canActivate: [NoAuthGuard] },
      { path: 'create-account', component: CreateAccountComponent, canActivate: [NoAuthGuard, ReferralGuard] },
      //fbPage is the same, the category changes.
      { path: 'referral', component: ReferralComponent, canActivate: [NoAuthGuard, ReferralGuard] },
      { path: '**', redirectTo: 'create-account' },
    ],
  },
  { path: '**', redirectTo: 'create-account' },
];
@NgModule({
  imports: [
    BrightsideUiModule,
    BrightsideUiServicesModule,
    CommonModule,
    DesktopDataAccessSharedModule,
    MicroUiMoleculeModule,
    NgxMaskModule.forRoot(ngxMaskOptions),
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    SharedConsentsModule,
    SharedDesktopModule,
    SharedDisplayModule,
    TranslateModule,
    SharedAccountModule
  ],
  declarations: [
    CreateAccountComponent,
    IdentityVerification,
    RegistrationComponent,
    SignInPromptComponent,
    LoginComponent,
    GetTheAppComponent,
    ReferralComponent,
  ],
  providers: [TranslatePipe],
})
export class DesktopFeatureRegistrationModule {}
